<template>
  <div class="vip-layout-background" :class="[{ 'px-12': $vuetify.breakpoint.mdAndUp },{'afterLogin':isLoggedIn}]">
    <router-view></router-view>
  </div>
</template>

<script>
import { locale, uiHelper } from '@/util'

export default {
  name: 'vipLayout',
  metaInfo: {
    title: `${locale.getMessage('meta.default_title')}`,
    titleTemplate: `%s | ${uiHelper.getHost()}`,
    meta: [{ charset: 'utf-8' }, { name: 'description', content: `${locale.getMessage('meta.default_description')}` }, { name: 'keyword', content: `${locale.getMessage('meta.default_keyword')}` }]
  },
  data: () => ({}),
  computed: {
    isLoggedIn() {
      return this.$store.state.member.isLoggedIn
    }
  },
  methods: {
    openLoginDialog() {
      this.$parent.openLoginDialog()
    },
    openRegisterDialog() {
      this.$parent.openRegisterDialog()
    }
  }
}
</script>

<style lang="scss">
.vip-layout-background {
  width: 100%;
  height: 100%;
  /*background: url("/static/image/GrabCoins/icon/bj.png") no-repeat top left;*/
  overflow-y: hidden;
  overflow-x: hidden;
  position: relative;
  margin: 0 auto;
  background-size: 100%;
  background: url('/static/image/background/vip-background.jpeg');
  padding-bottom: 60px;
}

.afterLogin {
  padding-bottom: unset !important;
}
@media (max-width: 959px) {
  .vip-layout-background {
    background: #333333 !important;
  }
}
</style>
